import { render, staticRenderFns } from "./ISRTXFRP.vue?vue&type=template&id=b1c065ee&scoped=true"
import script from "./ISRTXFRP.vue?vue&type=script&lang=js"
export * from "./ISRTXFRP.vue?vue&type=script&lang=js"
import style0 from "./ISRTXFRP.vue?vue&type=style&index=0&id=b1c065ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c065ee",
  null
  
)

export default component.exports